import DiscountStatusStepDTO from './DiscountStatusStepDTO';

export default class DiscountStatusDTO {
    totalSteps: number;

    completedSteps: number;

    steps: DiscountStatusStepDTO[];

    constructor({
        TotalSteps = 0,
        CompletedSteps = 0,
        Steps = []
    }: {
        TotalSteps?: number;
        CompletedSteps?: number;
        Steps?: { Key: string; IsCompleted: boolean }[];
    } = {}) {
        this.totalSteps = TotalSteps;
        this.completedSteps = CompletedSteps;
        this.steps = Steps.map(step => new DiscountStatusStepDTO(step));
    }
}
